import { useEffect, useState } from 'react';
import {
  IStatementActivityLookback,
  isValidStatementActivityLookback,
  MAX_STATEMENT_ACTIVITY_LOOKBACK,
  StatementActivityLookbackUnit,
} from 'shared';

import { Button } from '../../../../../../common/Atoms/Button';
import { InputTextAddon } from '../../../../../../common/Atoms/InputTextAddon';
import { Select } from '../../../../../../common/Atoms/Select';
import { Paragraph } from '../../../../../../common/Atoms/Typography/Paragraph';

interface BuilderActivityPeriodProps {
  activityLookback: IStatementActivityLookback;
  busy: boolean;
  onSave: (activityLookback: IStatementActivityLookback) => Promise<void>;
}

export function BuilderActivityPeriod({ activityLookback, busy, onSave }: BuilderActivityPeriodProps) {
  const [amount, setAmount] = useState<number | null>(activityLookback.amount);
  const [unit, setUnit] = useState(activityLookback.unit);

  // Follow the saved value when the AI, a reset or another template changes it
  useEffect(() => {
    setAmount(activityLookback.amount);
    setUnit(activityLookback.unit);
  }, [activityLookback.amount, activityLookback.unit]);

  const draft = { amount, unit };
  const valid = isValidStatementActivityLookback(draft);
  const changed = amount !== activityLookback.amount || unit !== activityLookback.unit;

  return (
    <div>
      <div className={ `flex items-end gap-3` }>
        <div className={ `w-72` }>
          <InputTextAddon
            label={ `Recent activity period` }
            name={ `activityLookbackAmount` }
            value={ amount ?? `` }
            dataType={ `number` }
            disabled={ busy }
            invalid={ valid || !changed ? undefined : { message: `1 to ${MAX_STATEMENT_ACTIVITY_LOOKBACK[unit]} ${unit}` } }
            onChange={ ({ value }) => setAmount(value === null ? null : Number(value)) }
            addOnElement={
              <Select
                name={ `activityLookbackUnit` }
                options={ [
                  { label: `Days`, value: `days` },
                  { label: `Months`, value: `months` },
                ] }
                selected={ unit }
                disabled={ busy }
                className={ `rounded-l-none` }
                nestedInTextField
                onChange={ ({ value }) => setUnit(value as StatementActivityLookbackUnit) }
              />
            }
          />
        </div>
        <Button
          color={ `white` }
          disabled={ busy || !changed || !valid }
          onClick={ () => valid && onSave(draft) }
        >
          { `Save` }
        </Button>
      </div>
      <Paragraph
        size={ `xs` }
        variant={ `secondary` }
        className={ `mt-1` }
      >
        { `How far back the recent activity section goes. Only applies if the template has a recent activity section. Publish to use a change on statements.` }
      </Paragraph>
    </div>
  );
}
